import {FETCH_TETRA_RESOURCES_LIST_REQUEST,FETCH_TETRA_RESOURCE_LIST_SUCCESS} from '../action/tetraResourcesAction';
import {TetraResourcesState} from '../state/tetraResourcesState';
var intialStatusCode=''
export function TetraResourcesReducer(state = TetraResourcesState, action) {
    switch (action.type) { 
        
            case FETCH_TETRA_RESOURCES_LIST_REQUEST:
                return Object.assign({}, state, {
                    isLoading: action.isLoading,
                    statusCode:intialStatusCode
                })
            case FETCH_TETRA_RESOURCE_LIST_SUCCESS:            
                return Object.assign({}, state, {
                    isLoading: action.isLoading,
                    tetraResourceList: action.tetraResourceList
                })  
              

                    
        default:
            return state;
    }
}
